<template>
  <TeamMembersSelect
    v-model:selected-team-members="selected_users"
    :excluded-contacts="workspace.team_members"
    :multi-select="true"
    :label="$t('Select Team Member')" />

  <SelectDropDownMenu
    v-model:current-item="team_member_permission"
    :is-box-background="true"
    :allow-null="false"
    name="tag"
    label-attr="label"
    value-attr="value"
    :items="permission_selections"
    :placeholder="$t('Permission')"
    :label="$t('Permission')"
    :show-label="true"
    class="w-44 font-normal mt-6"
    :input-classes="`w-full sm:text-sm appearance-none h-10 font-medium text-gray-700 text-left block px-1 py-2 rounded-lg shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light`" />

  <div class="flex gap-2 w-full flex-row justify-between mt-3">
    <button type="button" class="cancel-btn w-1/2 m-0 border-light-divider-border dark:border-dark-divider-border" @click="$emit('cancel')">
      {{ $t("Cancel") }}
    </button>
    <button :disabled="!required_filled" class="primary-btn w-1/2" @click="handleAddTeamMember">
      <span class="mr-5 whitespace-nowrap"> {{ $t("Add Team Member") }} </span>
    </button>
  </div>
</template>

<script>
import TeamMembersSelect from "@/components/shared/TeamMembersSelect.vue"

import SelectDropDownMenu from "@/components/shared/SelectDropDownMenu.vue"

export default {
  components: { TeamMembersSelect, SelectDropDownMenu },
  props: { workspace: null },
  emits: ["done", "cancel"],
  data() {
    return {
      selected_users: [],
      team_member_permission: "read",
      permission_selections: [
        { label: this.$t("Viewer"), value: "read" },
        { label: this.$t("Editor"), value: "write" },
        { label: this.$t("Admin"), value: "admin" }
      ]
    }
  },
  computed: {
    required_filled() {
      return this.selected_users.length
    }
  },
  watch: {},

  created() {},

  methods: {
    handleAddTeamMember() {
      let users_added = 0
      this.selected_users.forEach((selected_user) => {
        if (!this.workspace.team_members.map((t) => t.id).includes(selected_user.id)) {
          this.$store
            .dispatch("data/addWorkspaceTeamMember", {
              short_id: this.workspace.short_id,
              user: selected_user.id,
              access_scope: this.team_member_permission
            })
            .then(() => {
              users_added += 1
              if (users_added == this.selected_users.length) {
                this.$emit("done")
              }
            })
        } else {
          users_added += 1
        }

        if (users_added == this.selected_users.length) {
          this.$emit("done")
        }
      })
    }
  }
}
</script>
